module.exports = __webpack_public_path__ + "static/alexwork2-5ce68032a36f7e6346f4a866c4dc2e5e.jpg";